module.exports = __webpack_public_path__ + "static/media/pers-foto-b.882af1ef.jpg";